import { TableColumn } from '../../components/DataTable/TableColumn';
import { CustomerOrdersReport } from '../../interfaces/Report/CustomerOrdersReport/CustomerOrdersReport';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { Period } from '../../interfaces/Period';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import {
  getCreatedAtColumn,
  salesReportColumns,
} from '../SalesReport/SalesReportTable';

const additionalColumns: TableColumn<CustomerOrdersReport>[] = [
  {
    id: 'customer-name',
    name: 'Müşteri İsmi',
    accessor: (row) => <TextColumn value={row.customerName} />,
  },
  {
    id: 'email',
    name: 'Email',
    accessor: (row) => <TextColumn value={row.email} />,
  },
  {
    id: 'company-name',
    name: 'Müşteri Grubu',
    accessor: (row) => <TextColumn value={row.companyName ?? 'Misafir'} />,
  },
];

type CustomerOrdersReportTableProps = {
  rows: CustomerOrdersReport[];
  period?: Period;
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const CustomerOrdersReportTable = (
  props: CustomerOrdersReportTableProps,
) => {
  return (
    <DataTable
      columns={[
        getCreatedAtColumn(props.period),
        ...additionalColumns,
        ...salesReportColumns,
      ]}
      totalCount={props.totalCount}
      rows={props.rows}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
    />
  );
};
